import classNames from 'classnames';

import { Avatar } from 'shared/components/ui/Avatar/Avatar';
import { NULL_ADDRESS } from 'shared/constants/constants';
import useMediaQuery from 'shared/hooks/useMediaQuery';

import loseIcon from 'assets/png/defeat-icon.png';
import HeartEmpty from 'assets/png/heart-black.png';
import Heart from 'assets/png/heart-filled.png';
import victoryIcon from 'assets/png/victory-icon.png';

import './player-card.css';

interface Props {
  name: string;
  playerAddress: `0x${string}`;
  position: string;
  wins: number;
  isWinner?: boolean;
  isLooser?: boolean;
  winsTo: number;
}

export const PlayerCard = ({
  playerAddress,
  position,
  name,
  wins,
  winsTo,
  isWinner,
  isLooser,
}: Props) => {
  const isTablet = useMediaQuery('(max-width: 1200px)');

  const getRemainingWins = () => {
    return +winsTo - +wins;
  };
  const remainingWins = getRemainingWins();

  return (
    <div
      className={`
        flex flex-col w-full h-full max-w-[342px] max-h-[258px] items-center lg:py-4 rounded-[24px] 
        lg:border lg:border-border transition lg:bg-opacity-30 lg:bg-background 
        justify-between relative lg:watch-game-card 
      `}
    >
      <div className="flex flex-col items-center">
        <div className="flex flex-row lg:mb-[10px]">
          {playerAddress !== NULL_ADDRESS ? (
            <Avatar
              userAddress={playerAddress.toLowerCase() as `0x${string}`}
              className={`w-[54px] sm:w-[134px] lg:w-[64px] h-[54px] sm:h-[134px] lg:h-[64px] rounded-[8px] rounded-b-[0] lg:rounded-[12px]`}
            />
          ) : (
            <div className="w-[54px] sm:w-[64px] h-[54px] sm:h-[64px] flex justify-center items-center rounded-[12px] bg-deep-blue">
              <span className="text-blue text-[58px]">?</span>
            </div>
          )}
        </div>

        <div className="flex lg:block background-dark-background border border-border rounded-t-[0] rounded-b-lg lg:rounded-lg px-[8px] px-[4px] sm:px-[18.5px] lg:px-[32px] lg:py-[3px]">
          <span
            className="text-[#6A6B8A] lg:text-yellow text-[8px] sm:text-[20px]"
            style={{ opacity: playerAddress === NULL_ADDRESS ? 0 : 1 }}
          >
            {playerAddress.substring(0, 6)}......
            {!isTablet ? playerAddress.substring(playerAddress.length - 4) : null}
          </span>
        </div>

        <div className="background-dark-background border border-border rounded-tl-none rounded-tr-none rounded-bl-lg rounded-br-lg px-[32px] py-[3px] border-t-0 hidden lg:flex">
          <span className="text-gray text-[14px]">{name}</span>
        </div>

        {!isWinner && !isLooser ? (
          <div
            className={classNames(
              'flex gap-[3px] lg:gap-4 text-white mt-[8px] lg:mt-[24px]',
              remainingWins !== null ? 'animate-fast-appear' : '',
              position === 'order-3' ? 'transform scale-x-[-1]' : '',
            )}
          >
            {remainingWins !== null &&
              Array.from({ length: remainingWins }).map((_, index) => (
                <img
                  key={`heart-${index}`}
                  src={Heart}
                  alt=""
                  className="w-[16px] h-[15px] sm:w-[39px] sm:h-[37px] lg:w-[66px] lg:h-[60px]"
                />
              ))}
            {remainingWins !== null &&
              Array.from({ length: winsTo - remainingWins }).map((_, index) => (
                <img
                  key={`heart-empty-${index}`}
                  src={HeartEmpty}
                  alt=""
                  className="w-[16px] h-[15px] sm:w-[39px] sm:h-[37px] lg:w-[66px] lg:h-[60px]"
                />
              ))}
          </div>
        ) : null}

        {isWinner ? (
          <div className="flex flex-col items-center mt-[12px]">
            <span className="hidden lg:flex font-[900] text-[48px] leading-[64px] victory-title text-white">
              Victory
            </span>
            <img src={victoryIcon} alt="victory" className="w-[88px] lg:w-[236px]" />
          </div>
        ) : null}

        {isLooser ? (
          <div className="flex flex-col items-center mt-[12px]">
            <div className="hidden lg:flex font-[900] text-[48px] leading-[64px] defeat-title text-white">
              Defeat
            </div>
            <img src={loseIcon} alt="defeat" className="w-[88px] lg:w-[236px]" />
          </div>
        ) : null}
      </div>
    </div>
  );
};
